
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const helpSlice = createSlice({
    name: 'helps',
    loading: false,
    initialState: {
        helplist: []
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.helplist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.helplist = action.payload.data?action.payload.data:[];
        }
    }
});


export const { listReceived, listRequested ,listRequestFailed } = helpSlice.actions;
//console.log(body);
export const fetchHelps = (body) => apiCallBegan({
    url: '/category/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














